
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Rouen dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO est une agence Google Ads à Rouen certifiée Google Partner, accompagne les entreprises rouennaises pour accroître leur visibilité en ligne et attirer plus de prospects.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Rouen dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO est une agence Google Ads à Rouen certifiée Google Partner, accompagne les entreprises rouennaises pour accroître leur visibilité en ligne et attirer plus de prospects.",
        },
      ],
    };
  },
};
